"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerService = void 0;
const history_1 = require("../models/history");
const api_1 = require("./api");
const PATH_V1 = '/ledger/api/v1';
const PATH_V2 = '/ledger/api/v2';
class LedgerService {
    static async getUserTokens() {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/balance`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getBalance(currency) {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/balance/${currency}`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltyPointsBalance() {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V2}/balance`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltyPointsExpiring() {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V2}/balance/expiring`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltyExpiryAmount() {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V2}/balance/loyalty-expiry-amount`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async redeemFromPoints(payload) {
        const response = await api_1.API.post({
            url: `${PATH_V1}/transaction/redeem-from-points`,
            body: payload
        });
        return response;
    }
    static async convertPointsToTokensV2(payload) {
        const response = await api_1.API.post({
            url: `${PATH_V2}/conversion/points-to-tokens`,
            body: payload
        });
        return response;
    }
    static async getTransactionHistory(params) {
        let query = '';
        if (!!params) {
            const { filters, page, size } = params;
            if (filters) {
                query = filters;
            }
            if (page) {
                query += query.trim().length > 0 ? `&page=${page}` : `page=${page}`;
            }
            if (size) {
                query += query.trim().length > 0 ? `&size=${size}` : `size=${size}`;
            }
        }
        if (query.length > 0) {
            query = `?${query}`;
        }
        const url = `${PATH_V1}/transaction${query}`;
        try {
            const response = await api_1.API.get({
                url
            });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getUserActivitiesHistory(page, size, dateStart = '', dateEnd = '') {
        let requestParams = { size, page, type: 'CREDIT' };
        if (!!dateStart && !!dateEnd) {
            requestParams = Object.assign(Object.assign({}, requestParams), { startDate: dateStart, endDate: dateEnd });
        }
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/transaction/loyalty`,
                query: requestParams
            });
            return Object.assign(Object.assign({}, response), { content: history_1.HistoryActivity.LegerJsonToActivities(response.content) });
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltyTransactionHistory(page, size, dateStart = '', dateEnd = '') {
        let requestParams = { size, page };
        if (!!dateStart && !!dateEnd) {
            requestParams = Object.assign(Object.assign({}, requestParams), { startDate: dateStart, endDate: dateEnd });
        }
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/transaction/loyalty`,
                query: requestParams
            });
            return Object.assign(Object.assign({}, response), { content: history_1.HistoryActivity.LegerJsonToActivities(response.content), page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                } });
        }
        catch (e) {
            throw e;
        }
    }
    static async getLoyaltyDebitTransactionHistory(page, size, dateStart, dateEnd) {
        let requestParams = { size, page, type: 'DEBIT' };
        if (!!dateStart && !!dateEnd) {
            requestParams = Object.assign(Object.assign({}, requestParams), { startDate: dateStart, endDate: dateEnd });
        }
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/transaction/loyalty`,
                query: requestParams
            });
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getLoyaltyCreditTransactionHistory(page, size, dateStart = '', dateEnd = '') {
        let requestParams = { size, page, type: 'CREDIT' };
        if (!!dateStart && !!dateEnd) {
            requestParams = Object.assign(Object.assign({}, requestParams), { startDate: dateStart, endDate: dateEnd });
        }
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/transaction/loyalty`,
                query: requestParams
            });
            return Object.assign(Object.assign({}, response), { content: response.content, page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                } });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.LedgerService = LedgerService;
//# sourceMappingURL=ledger-service.js.map